export const FORM_IDENTIFIER = 'app/CorporateDonationDonateFormPage';

export const INIT = 'app/CorporateDonationDonateFormPage/INIT';
export const INIT_SUCCESS = 'app/CorporateDonationDonateFormPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/CorporateDonationDonateFormPage/INIT_FAILED';

export const SUBMIT = 'app/CorporateDonationDonateFormPage/SUBMIT';
export const SUBMIT_SUCCESS = 'app/CorporateDonationDonateFormPage/SUBMIT_SUCCESS';
export const SUBMIT_FAILED = 'app/CorporateDonationDonateFormPage/SUBMIT_FAILED';

export interface InitAction {
  type: typeof INIT;
}
export const initAction = () => ({
  type: INIT,
});
export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});
export const initFailedAction = (error: Error) => ({
  type: INIT_FAILED,
  error,
});

export interface SubmitAction {
  type: typeof SUBMIT;
  data: Record<string, unknown>;
}
export const submitAction = (data: Record<string, unknown>): SubmitAction => ({
  type: SUBMIT,
  data,
});
export const submitSuccess = (data: Record<string, unknown>) => ({
  type: SUBMIT_SUCCESS,
  data,
});
export const submitFailed = (error?: string, errorCode?: string | number) => ({
  type: SUBMIT_FAILED,
  error,
  errorCode,
});
